import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-16 md:py-24 bg-background-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-100 mb-3">精选文章</h2>
            <p className="text-foreground-500 text-base">夜行者们的深度好文，值得细细品读</p>
          </div>
          <Link
            to="/category/night-life"
            className="text-primary-400 hover:text-primary-300 text-sm flex items-center gap-1 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featured.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group relative overflow-hidden rounded-xl bg-background-950 border border-background-800/50 hover:border-primary-500/20 transition-all duration-300 cursor-pointer ${
                index === 0 ? 'md:col-span-2 md:flex' : ''
              }`}
            >
              {/* Image */}
              <div className={`relative overflow-hidden ${index === 0 ? 'md:w-1/2 md:h-auto h-52' : 'h-52'}`}>
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-primary-500/20 text-primary-400 text-xs font-medium">
                    {article.categoryName}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className={`p-6 ${index === 0 ? 'md:w-1/2' : ''}`}>
                <div className="flex items-center gap-3 text-xs text-foreground-600 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {article.publishDate}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                </div>
                <h3 className={`font-heading text-foreground-100 group-hover:text-primary-400 transition-colors duration-200 mb-3 ${
                  index === 0 ? 'text-xl md:text-2xl' : 'text-lg'
                }`}>
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2">
                  <img
                    src={article.authorAvatar}
                    alt={article.author}
                    className="w-7 h-7 rounded-full object-cover"
                    loading="lazy"
                  />
                  <span className="text-sm text-foreground-500">{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}